import '@/assets/css/tabler-buttons.min.css'
import '@/assets/css/tabler.css'
import '@/assets/css/common.css'
import '@/assets/scss/main.scss'

import '@/assets/libs/jquery/dist/jquery.slim.min.js'
import '@/assets/libs/bootstrap/dist/js/bootstrap.bundle.min'
import '@/assets/js/tabler.min'

import './axios'
import './bootstrap-vue'

import * as moment from 'moment-timezone'

moment.locale('vi')
moment.tz.setDefault('Japan')



// WEBPACK FOOTER //
// ./src/plugins/index.js